import { call, put, takeEvery, takeLatest } from 'redux-saga/effects';
import { apiWrapper } from "../../../api/apiWrapper";
import { IBaseResponeModel } from '../../../models/response/base-response';
import { dm_ket_qua_lien_he } from '../../../models/response/category/dm_ket_qua_lien_he';
import { eDmKetQuaLienHeActionTypeIds, IDmKetQuaLienHeActionTypes } from '../../action-types/crm-category/IDmKetQuaLienHeActionTypes';
import { actions } from '../../actions/actionsWrapper';

export function* dmKetQuaLienHeSaga(): any {
    yield takeLatest(eDmKetQuaLienHeActionTypeIds.LOAD_START, loadWorker)
    yield takeEvery(eDmKetQuaLienHeActionTypeIds.SAVE_START, saveWorker)
    yield takeEvery(eDmKetQuaLienHeActionTypeIds.DELETE_START, deleteWorker)
}

function* loadWorker(action: IDmKetQuaLienHeActionTypes): any {
    const dm_coso_id: number = action.payload as number;
    const res: IBaseResponeModel = yield call(apiWrapper.crmCategoryWrapper.ketQuaLienHe.select_by_coso, dm_coso_id)
    if (res.is_success) {
        yield put(actions.crmCategoryWrapper.ketQuaLienHe.LOAD_SUCCESS(res.data))
    } else {
        yield put(actions.crmCategoryWrapper.ketQuaLienHe.LOAD_ERROR(res.message ?? "Error"))
    }
}

function* saveWorker(action: IDmKetQuaLienHeActionTypes): any {
    const payload: dm_ket_qua_lien_he = action.payload as dm_ket_qua_lien_he;
    let res: IBaseResponeModel;
    if (payload.id > 0) {
        res = yield call(apiWrapper.crmCategoryWrapper.ketQuaLienHe.update, payload)
    } else {
        res = yield call(apiWrapper.crmCategoryWrapper.ketQuaLienHe.insert, payload)
    }
    if (res.is_success) {
        yield put(actions.crmCategoryWrapper.ketQuaLienHe.SAVE_SUCESS(res.data))
    } else {
        yield put(actions.crmCategoryWrapper.ketQuaLienHe.SAVE_ERROR(res.message ?? "Error"))
    }
}

function* deleteWorker(action: IDmKetQuaLienHeActionTypes): any {
    const payload: number = action.payload as number;
    const res: IBaseResponeModel = yield call(apiWrapper.crmCategoryWrapper.ketQuaLienHe.delete, payload)
    if (res.is_success) {
        yield put(actions.crmCategoryWrapper.ketQuaLienHe.DELETE_SUCESS(undefined))
    } else {
        yield put(actions.crmCategoryWrapper.ketQuaLienHe.DELETE_ERROR(res.message ?? "Error"))
    }
}
